<div class="container">
  <div class="row justify-content-center register-form">
    <form class="form-box login-form form-validator" [formGroup]="signupForm" (ngSubmit)="onSubmit()">
      <p class="col">Create a Vistek account for a more personalized shopping experience.</p>
      <div class="alert alert-danger col" role="alert" *ngIf="this.errorMessage">
        {{ this.errorMessage }}
      </div>
      <div class="form-group label-floating is-empty col">
        <label class="control-label">First Name<span class="required">*</span></label>

        <input
          type="text"
          class="form-control"
          formControlName="firstname"
          [ngClass]="{
            'is-invalid': (f.firstname.touched && f.firstname.errors) || (f.firstname.errors && this.submitted)
          }"
          id="firstname"
          data-testid="create-account-first-name"
        />

        <div
          *ngIf="(!f.firstname.valid && f.firstname.touched) || (f.firstname.errors && this.submitted)"
          class="help-block"
        >
          <div *ngIf="f.firstname.errors.required">First Name is required</div>
          <div *ngIf="f.firstname.errors.minlength">First Name must be at least 2 character long</div>
          <div *ngIf="f.firstname.errors.pattern">First Name must be only letters, spaces, hyphens, apostrophes or dots.</div>
        </div>
      </div>
      <div class="form-group label-floating is-empty col">
        <label class="control-label">Last Name<span class="required">*</span></label>

        <input
          type="text"
          class="form-control"
          formControlName="lastname"
          [ngClass]="{
            'is-invalid': (f.lastname.touched && f.lastname.errors) || (f.lastname.errors && this.submitted)
          }"
          id="lastname"
          data-testid="create-account-last-name"
        />

        <div
          *ngIf="(f.lastname.errors && f.lastname.touched) || (f.lastname.errors && this.submitted)"
          class="help-block"
        >
          <div *ngIf="f.lastname.errors.required">Last Name is required</div>
          <div *ngIf="f.lastname.errors.minlength">Last Name must be at least 2 character long</div>
          <div *ngIf="f.lastname.errors.pattern">Last Name must be only letters, spaces, hyphens, apostrophes or dots.</div>
        </div>
      </div>

      <div class="form-group label-floating is-empty col">
        <label class="control-label">Email<span class="required">*</span></label>

        <input
          type="text"
          class="form-control"
          formControlName="email"
          [ngClass]="{ 'is-invalid': (f.email.touched && f.email.errors) || (f.email.errors && this.submitted) }"
          data-testid="create-account-email"
        />
        <div *ngIf="(f.email.errors && f.email.touched) || (f.email.errors && this.submitted)" class="help-block">
          <div *ngIf="f.email.errors.emailExists">
            The account already exists. Please <a href="#" (click)="onAccountExists($event, 'login')">login</a> or
            <a href="#" (click)="onAccountExists($event, 'passwordreset')">reset password</a>.
          </div>
          <div *ngIf="f.email.errors.required">Email is required</div>
          <div *ngIf="f.email.errors.email">Email is invalid</div>
          <div *ngIf="f.email.errors.maxlength">Email's maximum length is 80 symbols</div>
        </div>
      </div>

      <div class="form-group label-floating is-empty col">
        <label class="control-label">Password<span class="required">*</span></label>
        <div class="input-group">
          <input data-private
            [type]="passowrdTextType ? 'text' : 'password'"
            formControlName="password"
            class="form-control"
            [ngClass]="{
              'is-invalid': (f.password.touched && f.password.errors) || (f.password.errors && this.submitted)
            }"
          data-testid="create-account-password"
          />

          <div class="input-group-append">
            <span class="input-group-text">
              <i
                class="fa"
                [ngClass]="{
                  'fa-eye-slash': !passowrdTextType,
                  'fa-eye': passowrdTextType
                }"
                (click)="togglePasswordTextType()"
              ></i>
            </span>
          </div>
        </div>
        <ng9-password-strength-bar
          [passwordToCheck]="f.password.value"
          [customThresholds]="thresholds"
          [barColors]="myColors"
          [strengthLabels]="strengthLabels"
        >
        </ng9-password-strength-bar>
        <div
          *ngIf="(f.password.touched && f.password.errors) || (f.password.errors && this.submitted)"
          class="help-block"
        >
          <div *ngIf="f.password.errors.required">Password is required</div>
          <div *ngIf="f.password.errors.minlength">Password must be at least 8 characters</div>
          <div *ngIf="f.password.errors.maxlength">Password must not exceed 40 characters</div>
        </div>
        <div class="note note-info small">Password must be at least 8 characters with at least one number</div>
      </div>
      <div class="form-group label-floating is-empty col">
        <label class="control-label">Confirm Password<span class="required">*</span></label>
        <div class="input-group">
          <input data-private
            [type]="confirmPassowrdTextType ? 'text' : 'password'"
            formControlName="confirmpassword"
            class="form-control"
            [ngClass]="{
              'is-invalid':
                (f.confirmpassword.touched && f.confirmpassword.errors) || (f.confirmpassword.errors && this.submitted)
            }"
          data-testid="create-account-confirm-password"
          />
          <div class="input-group-append">
            <span class="input-group-text">
              <i
                class="fa"
                [ngClass]="{
                  'fa-eye-slash': !confirmPassowrdTextType,
                  'fa-eye': confirmPassowrdTextType
                }"
                (click)="toggleconfirmPasswordTextType()"
              ></i>
            </span>
          </div>
        </div>
        <div
          *ngIf="
            (f.confirmpassword.touched && f.confirmpassword.errors) || (f.confirmpassword.errors && this.submitted)
          "
          class="help-block"
        >
          <div *ngIf="f.confirmpassword.errors.required">Confirm Password is required</div>

          <div *ngIf="f.confirmpassword.errors.matching">Confirm Password does not match</div>
        </div>
      </div>
      <div class="buttons-box clearfix col">
        <!--[disabled]="this.signupForm.invalid" -->
        <button type="submit" class="btn btn-primary btn-raised btn-block" [ngClass]="{ disabled: f.email.pending }"
          data-testid="create-account-submit">
          <i class="fas fa-user-check"></i> Create</button
        ><br />
      </div>
    </form>
  </div>
</div>
